// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"2dc1f9a0","549":"f12672c9","579":"870f2cf8","768":"defdaa08","860":"fc0e0cf7","955":"fdfecbad","983":"a461a401"}[chunkId] + ".chunk.js";
};